import { useNuxtData, useRoute } from '#imports'
import { computed } from 'vue'

import { PRODUCT as ROUTE_NAMES } from '../../route-names'

export function useMasterPPScale(route = useRoute()) {
  const { data } = useNuxtData(`MasterPP-${route.params.slug}`)

  const masterPPScaleProductId = computed(() => data.value?.productId)
  const masterPPScaleGrade = computed(() => data.value?.grade)
  const masterPPScaleSpecialOfferType = computed(
    () => data.value?.specialOfferType,
  )

  const isMasterPPScaleUrl = computed(
    () => route.name === ROUTE_NAMES.MASTER_PP,
  )

  return {
    masterPPScaleProductId,
    masterPPScaleGrade,
    masterPPScaleSpecialOfferType,
    isMasterPPScaleUrl,
  }
}
